import React from "react";
export class DownChevronIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { active, className } = this.props;
        const fill = active ? "#C20000" : "#373435";
        return (<svg width="15" height="15" viewBox="0 0 15 15" className={className} xmlns="http://www.w3.org/2000/svg">
				<path d="m6.473 7.718 4.622 4.885a.711.711 0 0 1 -.023.999.694.694 0 0 1 -.988-.023l-5.546-5.861 5.537-5.852a.694.694 0 0 1 .988-.023c.28.27.29.717.023.999z" fill={fill} stroke={fill} strokeWidth=".5" transform="matrix(0 -1 1 0 .191 15.635)"/>
			</svg>);
    }
}
